module.exports = __webpack_public_path__ + "static/media/ps_voltage_screen.52f5e310.svg";